<util-progress [bar]="true" *ngIf="loading"></util-progress>
<div class="post-last-step-gallery mb-3">
  <div class="mb-3">
    <div class="p-2" *ngIf="images.thumbs.length>0">
      <small class="muted">Previous Images</small><br/>
      <img class="avatar-md border rounded object-fit-cover m-1" *ngFor="let t of images.thumbs" src="{{t}}"
           (click)="removeExImage(t)" alt="">
    </div>
    <div class="p-2" *ngIf="uploadFiles.length>0">
      <small class="muted">Selected New Images</small><br/>
      <img class="avatar-md border rounded object-fit-cover m-1" *ngFor="let uf of uploadFiles" src="{{uf.previewUrl}}"
           (click)="removeImage(uf)" alt="">
    </div>

  </div>

  <label class="form-label">{{ title }}</label>
  <div class="input-group mb-3">
    <label for="image-upload"><i class="flaticon-add"></i></label>
    <input type="file" class="form-control" id="image-upload" (change)="onImageSelected($event)">
  </div>
  <h6 class="mt-3 text-danger" *ngIf="msg.length>0">{{ msg }}</h6>
</div>

